import { useMemo } from 'react';
import { findLatestPlanningScan } from './scanTakenAt';
import { useDmScanDetail, useDmScans, type DmScansQueryConfig } from './useDmScansQueries';
import type { DmScanDetail, DmScanSummary } from './types';

export interface LatestScanDetail {
    latestScan: DmScanSummary | null;
    detail: DmScanDetail | null | undefined;
    isLoading: boolean;
}

// One definition of "latest" for every summary surface. Both queries are keyed
// like the tab's own, so extra callers read cache rather than refetching.
export function useLatestScanDetail(
    queries: DmScansQueryConfig,
    patientId: string | null,
    dmId: number | null | undefined
): LatestScanDetail {
    const { data: list, isLoading: scansLoading } = useDmScans(queries, patientId, dmId);
    const scans = list?.scans;

    const latestScan = useMemo(() => findLatestPlanningScan(scans ?? []), [scans]);

    const { data: detail, isLoading: detailLoading } = useDmScanDetail(
        queries,
        patientId,
        latestScan?.scanId ?? null
    );

    return {
        latestScan,
        detail,
        isLoading: scansLoading || (!!latestScan && detailLoading)
    };
}
